"use client";
import { useEffect, useState } from "react";
import useIntersectionObserverOnlyOnce from "../hooks/useInteractionObserverOnlyOnce";

function CountUp({ end, duration = 5 }: { end: number; duration?: number }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    const startTime = performance.now();
    const durationMs = duration * 1000;
    let frame = 0;

    const tick = (now: number) => {
      const progress = Math.min((now - startTime) / durationMs, 1);
      setValue(Math.round(end * progress));
      if (progress < 1) {
        frame = requestAnimationFrame(tick);
      }
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [end, duration]);

  return <>{value}</>;
}

export default function CounterSection() {
  const [ref, inView] = useIntersectionObserverOnlyOnce({ threshold: 0.2 });

  const counters = [
    { title: "Umgesetzte Projekte", value: 5968 },
    { title: "Jahre Erfahrung", value: 32 },
    { title: "Mitarbeiter", value: 40 },
  ];

  return (
    <div className="bg-company-color-primary text-white py-16">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-8">Worauf wir stolz sind</h2>
        <div className="grid grid-cols-3 md:grid-cols-3 gap-8" ref={ref}>
          {counters.map((counter, index) => (
            <div key={index} className="flex flex-col items-center">
              <span className="text-4xl font-bold">
                {inView ? <CountUp end={counter.value} duration={5} /> : 0}
              </span>
              <p className="text-white">{counter.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
